import { render, staticRenderFns } from "./AdminHospitalDakaRecordPage.vue?vue&type=template&id=340168c8&scoped=true"
import script from "./AdminHospitalDakaRecordPage.vue?vue&type=script&lang=js"
export * from "./AdminHospitalDakaRecordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340168c8",
  null
  
)

export default component.exports